import React, { useEffect, useState } from "react";
import { LayoutDashboard, CalendarDays, DollarSign, TrendingUp, Users, Loader2, ShieldCheck } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, PieChart, Pie, Cell } from "recharts";
import api from "../../lib/api";
import { Stat } from "./common";

export default function Overview() {
  const [r, setR] = useState(null);
  const [bk, setBk] = useState([]);
  useEffect(() => { api.get("/admin/reports").then((x) => setR(x.data)).catch(() => {}); }, []);
  useEffect(() => { api.get("/admin/bookings").then((x) => setBk(x.data)).catch(() => {}); }, []);
  if (!r) return <Loader2 className="animate-spin text-rose" />;
  const statusData = Object.entries(r.by_status).map(([name, value]) => ({ name, value }));
  const colors = ["#9E4747", "#C5A059", "#2C4A3E", "#8C6D58", "#5A6B5C", "#B98A5E"];
  const awaiting = bk.filter((b) => b.verification_status === "pending").length;
  const rejected = bk.filter((b) => b.verification_status === "rejected").length;
  return (
    <div className="space-y-6">
      {awaiting > 0 && (
        <div className="rounded-xl bg-amber-50 border border-amber-200 px-5 py-4 flex items-center gap-3" data-testid="overview-awaiting-banner">
          <div className="h-10 w-10 rounded-full bg-amber-100 flex items-center justify-center text-amber-700 shrink-0"><ShieldCheck size={20} /></div>
          <div>
            <div className="font-semibold text-forest">{awaiting} booking{awaiting > 1 ? "s" : ""} awaiting ID review</div>
            <div className="text-xs text-stone-500">Open the Bookings tab and use the “Awaiting ID review” filter to approve these reservations{rejected > 0 ? ` · ${rejected} rejected awaiting guest re-upload` : ""}.</div>
          </div>
        </div>
      )}
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <Stat icon={ShieldCheck} label="Awaiting ID review" value={awaiting} hint={rejected > 0 ? `${rejected} rejected` : "all clear"} />
        <Stat icon={DollarSign} label="Revenue" value={`$${r.revenue.toLocaleString()}`} hint={`${r.paid_bookings} paid bookings`} />
        <Stat icon={CalendarDays} label="Total bookings" value={r.total_bookings} />
        <Stat icon={Users} label="Nights sold" value={r.nights_sold} />
        <Stat icon={TrendingUp} label="Avg booking" value={`$${r.avg_booking}`} />
      </div>
      <div className="grid lg:grid-cols-3 gap-6">
        <div className="card-lux p-6 lg:col-span-2">
          <h3 className="font-serif text-xl text-forest mb-4">Revenue trend</h3>
          <ResponsiveContainer width="100%" height={260}>
            <BarChart data={r.trend}>
              <XAxis dataKey="month" tick={{ fontSize: 12 }} /><YAxis tick={{ fontSize: 12 }} />
              <Tooltip /><Bar dataKey="revenue" fill="#9E4747" radius={[6, 6, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div className="card-lux p-6">
          <h3 className="font-serif text-xl text-forest mb-4">Bookings by status</h3>
          <ResponsiveContainer width="100%" height={260}>
            <PieChart>
              <Pie data={statusData} dataKey="value" nameKey="name" outerRadius={90} label={(e) => e.name}>
                {statusData.map((_, i) => <Cell key={i} fill={colors[i % colors.length]} />)}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
